import { motion } from "framer-motion";
import { Camera, Clock } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { WhatsAppButton, PreventivoButton } from "./CTAs";
import { neutralizeWA } from "../../config";

export default function InterventoRapido() {
  return (
    <section id="intervento" className="relative bg-navy text-white py-20 sm:py-28 overflow-hidden">
      <div className="noise-overlay" />
      <div className="pointer-events-none absolute -right-20 top-10 h-80 w-80 rounded-full bg-brand-orange/20 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <Reveal><Overline>Intervento rapido</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display font-extrabold tracking-tight text-4xl sm:text-5xl leading-[1.02]">
              Hai bisogno di un lavoro veloce?
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-white/75 text-base sm:text-lg leading-relaxed max-w-xl">
              {neutralizeWA("Hai bisogno di imbiancare una casa, sistemare una parete, rifare un bagno o eseguire un piccolo lavoro di muratura? Scrivici su WhatsApp oppure inviaci alcune fotografie.")}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-4 text-white/75 text-base sm:text-lg leading-relaxed max-w-xl">
              Ti risponderemo nel più breve tempo possibile con una valutazione e, se
              necessario, organizzeremo un sopralluogo.
            </p>
          </Reveal>
          <Reveal delay={0.2} className="mt-8 flex flex-col sm:flex-row gap-3">
            <WhatsAppButton testid="intervento-whatsapp" label="Scrivici su WhatsApp" />
            <PreventivoButton variant="outlineLight" testid="intervento-preventivo" label="Preventivo Online" />
          </Reveal>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {[
            { icon: Camera, title: "Inviaci le foto", desc: "Scattaci qualche foto del lavoro e ti diamo una prima valutazione." },
            { icon: Clock, title: "Risposta rapida", desc: "Ti ricontattiamo nel più breve tempo possibile, senza attese." },
          ].map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6"
              >
                <div className="h-12 w-12 rounded-xl bg-brand-orange/15 flex items-center justify-center text-brand-orange">
                  <Icon size={24} />
                </div>
                <h3 className="mt-4 font-display font-bold text-lg">{c.title}</h3>
                <p className="mt-2 text-sm text-white/65 leading-relaxed">{c.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
